import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import { Legend, PieChart3D, PieSeries3D } from '@amcharts/amcharts4/charts';

import { COLOR_FONT_1 } from '../../colors';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class ThreeDPieChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, PieChart3D);
    chart.data = data;
    chart.depth = 120;
    chart.innerRadius = am4core.percent(40);

    // -- series
    const series = chart.series.push(new PieSeries3D());
    series.calculatePercent = true;
    series.colors.step = 3;
    series.dataFields.value = 'count';
    series.dataFields.depthValue = 'count';
    series.dataFields.category = 'name_display';
    series.labels.template.disabled = true;
    // series.labels.template.fill = am4core.color(COLOR_FONT_1);
    // series.labels.template.text = "{category} [bold]{value.percent.formatNumber('0.0')}%[/]";
    series.slices.template.cornerRadius = 5;
    series.slices.template.draggable = false;
    series.slices.template.inert = true;
    series.ticks.template.stroke = am4core.color(COLOR_FONT_1);
    series.ticks.template.strokeOpacity = 0.3;

    // -- legend
    chart.legend = new Legend();
    chart.legend.disabled = false;
    chart.legend.position = 'left';
    chart.legend.labels.template.fill = am4core.color(COLOR_FONT_1);
    chart.legend.labels.template.truncate = false;
    chart.legend.valueLabels.template.fill = am4core.color(COLOR_FONT_1);

    // -- responsive
    chart.responsive.enabled = true;
    chart.responsive.useDefault = false;
    chart.responsive.rules.push({
      relevant: (target) => target.pixelWidth < 1024,
      state: (target, stateId) => {
        if (target instanceof Legend) {
          const state = target.states.create(stateId);
          const legendState = target.states.create(stateId);
          legendState.properties.disabled = true;
          return state;
        }
        return null;
      }
    });

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '544px' }} />;
  }
}

ThreeDPieChart.propTypes = {
  chartId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({ name_display: PropTypes.string.isRequired, count: PropTypes.number.isRequired })
  ).isRequired
};
